import { render, staticRenderFns } from "./GameItemsListFilter.vue?vue&type=template&id=1438d260&"
import script from "./GameItemsListFilter.vue?vue&type=script&lang=js&"
export * from "./GameItemsListFilter.vue?vue&type=script&lang=js&"
import style0 from "./GameItemsListFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports